import { QueryProvider } from "@/providers/QueryProvider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/providers/ThemeProvider";
import App from "@/App";

export default function AppContainer() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
      storageKey="cash-forecaster-theme"
    >
      <QueryProvider>
        <TooltipProvider>
          <Toaster richColors duration={5000} closeButton />
          <App />
        </TooltipProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
